<template>
    <div>
        <div class="col-md-8">
            <div class="block-content">
                <span class="text-danger"
                    >New password should be different from old password</span
                >
                <div v-if="errors" class="text-danger">
                    <ul>
                        <li v-for="error in errors">{{ error.toString() }}</li>
                    </ul>
                </div>
                <form action @submit.prevent="updatePassword">
                    <div class="form-group">
                        <div class="form-material">
                            <input
                                type="password"
                                class="form-control"
                                id="old_password"
                                v-model="form.old_password"
                            />
                            <label for="old_password">Old Password</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-material">
                            <input
                                type="password"
                                class="form-control"
                                id="password"
                                v-model="form.password"
                            />
                            <label for="password">New Password</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-material">
                            <input
                                type="password"
                                class="form-control"
                                id="password_confirm"
                                v-model="form.confirm_password"
                            />
                            <label for="password_confirm"
                                >Confirm Password</label
                            >
                        </div>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-info mb-10">
                            Update password
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            errors: [],
            file: "",
            user: "",
            withdrawals: [],
            images: {},
            image: {},
            form: new Form({
                password: "",
                confirm_password: "",
                old_password: ""
            })
        };
    },
    methods: {
        onFileChanged(event) {
            let uploadedFiles = event.target.files[0];
            this.file = uploadedFiles;
        },
        onUpload() {
            const formData = new FormData();
            let filename = this.file;
            formData.append("identification", filename);
            formData.append("user", this.user.id);

            UsersRepository.uploadFiles(formData)
                .then(() => {
                    Fire.$emit("refresh");
                    toast.fire({
                        type: "success",
                        title: "File upload successful"
                    });
                })
                .catch(() => {
                    toast({
                        type: "warning",
                        title: "Failed to upload file"
                    });
                });
        },
        updatePassword() {
            axios.get("/api/user").then(response => {
                this.user = response.data;
                let data = {
                    user: response.data.id,
                    old_password: this.form.old_password,
                    password: this.form.password,
                    password_confirmation: this.form.confirm_password
                };
                UsersRepository.passwordUpdate(data)
                    .then(response => {
                        Fire.$emit("Refresh");
                        toast.fire({
                            type: response.data.status,
                            title: response.data.message
                        });
                    })
                    .catch(errors => {
                        if (errors.response.status == 422) {
                            this.errors = errors.response.data.errors;
                        }
                        Fire.$emit("Refresh");
                        toast({
                            type: "warning",
                            title: "Update failed"
                        });
                        this.form.reset();
                    });
            });
        }
    },
    created() {
        Fire.$on("Refresh", () => {});
    },
    mounted() {
        axios.get("/api/user").then(response => {
            this.user = response.data;
            UsersRepository.userWithdrawals(response.data.id).then(response => {
                this.withdrawals = response.data;
            });
        });
    }
};
</script>

<style scoped></style>
